// Action Types
export const FETCH_INCREASE_DEAL_SIZE_CARD_REQUEST = "FETCH_INCREASE_DEAL_SIZE_CARD_REQUEST";
export const FETCH_INCREASE_DEAL_SIZE_CARD_SUCCESS = "FETCH_INCREASE_DEAL_SIZE_CARD_SUCCESS";
export const FETCH_INCREASE_DEAL_SIZE_CARD_FAILURE = "FETCH_INCREASE_DEAL_SIZE_CARD_FAILURE";

// Action Creators
export const fetchIncreaseDealSizeCardRequest = ({deal_id}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_INCREASE_DEAL_SIZE_CARD_REQUEST,
      payload: {deal_id},
    });
  };
};
export const fetchIncreaseDealSizeCardSuccess = (data) => ({
  type: FETCH_INCREASE_DEAL_SIZE_CARD_SUCCESS,
  payload: data,
});
export const fetchIncreaseDealSizeCardFailure = (error) => ({
  type: FETCH_INCREASE_DEAL_SIZE_CARD_FAILURE,
  payload: error,
});
